import React, { useEffect } from "react"; // นำเข้า useEffect
import "./EsgPlatform.css";
import { useTranslation } from "react-i18next";

function EsgPlatform() {
  const { t, i18n } = useTranslation(); // ใช้งาน i18n จาก useTranslation

  useEffect(() => {
  }, [i18n.language]); // ติดตามการเปลี่ยนแปลงภาษา

  return (
    <div id="esg-content" className="esg-content">
      <div className="text-esg-platfrom">
        <div className="text-header-esg">ESG</div>
        <div className="sub-header-esg">
          {t("main_head_esg")}
        </div>
      </div>
      <div className="esg-image">
        <div className="esg-image-header">ESG</div>
        <div className="esg-image-sub">
          <li>{t("main_sub_esg_1")}</li>
          <li>{t("main_sub_esg_2")}</li>
          <li>{t("main_sub_esg_3")}</li>
        </div>
        {/* <a href="/" className="read-more-btn">
          Read More
        </a> */}
      </div>
    </div>
  );
}

export default EsgPlatform;
